import axios from 'axios'

const http = axios.create({
  baseURL: '/assistance/api/v1'
})
http.interceptors.response.use(res => {
  if (!res.data) {
    return res.data
  }
  if (res.data.code) {
    return Promise.reject(new Error(res.data.message))
  }
  return res.data.data
})

export default http
